<h2>Home View 2</h2>
<p>...just the next view your come across after logging in.</p>
<p><a [routerLink]="['/home/']">Link back to home / "dashboard"</a></p>
